module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Alterar senha")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t10"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Deseja alterar sua senha? Ao clicar no botão abaixo você será redirecionado para a página de alteração.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "id": "btn-new-pass",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                  Definir nova senha\n                ")])])])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-42d4cfa4!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/password-change-confirmation.vue
// module id = 2111
// module chunks = 1